// src/data/pageCTA.js
// Custom CTA content per page.
// Keys match PAGE_COMPONENTS keys from pageRegistry.

export const PAGE_CTA = {

  Home: {
    label: "Ready to Begin",
    heading: "Intelligence is a Choice. Make It.",
    description: "Explore our products, understand the intelligence layer powering them, or get in touch to start a conversation.",
    buttons: (set) => [
      { label: "Explore Products",      variant: "primary",   onClick: () => set("Products") },
      { label: "Intelligence Corner",   variant: "secondary", onClick: () => set("Intelligence Corner") },
      { label: "Get In Touch →",        variant: "ghost",     onClick: () => set("Connect") },
    ],
  },

  VisionPhilosophy: {
    label: "From Philosophy to Practice",
    heading: "Ideas Without Execution Are Just Theory.",
    description: "See how our philosophy translates into products, explore the intelligence infrastructure behind them, or connect to talk about what we're building.",
    buttons: (set) => [
      { label: "Explore Products",      variant: "primary",   onClick: () => set("Products") },
      { label: "Intelligence Corner",   variant: "secondary", onClick: () => set("Intelligence Corner") },
      { label: "Get In Touch →",        variant: "ghost",     onClick: () => set("Connect") },
    ],
  },

  Products: {
    label: "Go Deeper",
    heading: "Products Are the Surface. Intelligence Is the Foundation.",
    description: "Understand the intelligence layer powering every product we build, explore our philosophy, or connect to discuss your use case.",
    buttons: (set) => [
      { label: "Vision & Philosophy",   variant: "primary",   onClick: () => set("Vision & Philosophy") },
      { label: "Intelligence Corner",   variant: "secondary", onClick: () => set("Intelligence Corner") },
      { label: "Get In Touch →",        variant: "ghost",     onClick: () => set("Connect") },
    ],
  },

  IntelligenceCorner: {
    label: "Put It to Work",
    heading: "Intelligence Without Application Is Just Potential.",
    description: "Take what you've explored here into the products we've built with it, join the team engineering it, or connect to discuss what it can do for you.",
    buttons: (set) => [
      { label: "Explore Products",      variant: "primary",   onClick: () => set("Products") },
      { label: "View Open Roles",       variant: "secondary", onClick: () => set("Career") },
      { label: "Get In Touch →",        variant: "ghost",     onClick: () => set("Connect") },
    ],
  },

  Career: {
    label: "Beyond the Role",
    heading: "The Work Matters. So Does the Platform.",
    description: "Understand the products you'd be building, explore the intelligence infrastructure beneath them, or reach out if you have questions before applying.",
    buttons: (set) => [
      { label: "Explore Products",      variant: "primary",   onClick: () => set("Products") },
      { label: "Intelligence Corner",   variant: "secondary", onClick: () => set("Intelligence Corner") },
      { label: "Get In Touch →",        variant: "ghost",     onClick: () => set("Connect") },
    ],
  },

  Connect: {
    label: "While You're Here",
    heading: "Conversation Starts With Context.",
    description: "Before we talk, explore what we believe, what we've built, and the intelligence layer powering it all.",
    buttons: (set) => [
      { label: "Vision & Philosophy",   variant: "primary",   onClick: () => set("Vision & Philosophy") },
      { label: "Explore Products",      variant: "secondary", onClick: () => set("Products") },
      { label: "Intelligence Corner →", variant: "ghost",     onClick: () => set("Intelligence Corner") },
    ],
  },

};